import React from 'react';
import styles from './TopBar5.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar5 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBarWrapper}>
      <div className={styles.container}>
        <div className={styles.glassBar}>
          
          {/* Left: Contact Chips */}
          <div className={styles.contactSection}>
            <div className={styles.contactChip}>
              <div className={styles.iconCircle}>
                <FaPhoneAlt />
              </div>
              <span className={styles.chipText}>{phone}</span>
            </div>

            <div className={styles.contactChip}>
              <div className={styles.iconCircle}>
                <FaEnvelope />
              </div>
              <span className={styles.chipText}>{email}</span>
            </div>
          </div>

          {/* Right: Social Icons */}
          <div className={styles.socialSection}>
            <div className={styles.socialLabel}>Connect:</div>

            <div className={styles.socialIcons}>
              <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.socialLink}>
                <FaFacebookF />
              </a>

              <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.socialLink}>
                <FaInstagram />
              </a>

              <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.socialLink}>
                <FaTwitter />
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TopBar5;